module.exports = __webpack_public_path__ + "static/media/tooltip-outline.22c753ce.svg";